import axios from 'axios';

// Use environment variable if set, otherwise use relative path
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const createRecord = async (section, patientId, eye, data, recordedBy = '') => {
  const response = await api.post(`/optics/${section}/${patientId}/${eye}`, {
    data,
    recorded_by: recordedBy,
  });
  return response.data;
};

export const getLatestRecord = async (section, patientId, eye) => {
  try {
    const response = await api.get(`/optics/${section}/${patientId}/${eye}/one`);
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const getAllRecords = async (section, patientId, eye) => {
  try {
    const response = await api.get(`/optics/${section}/${patientId}/${eye}/all`);
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return [];
    }
    throw error;
  }
};

